import { memo, useEffect } from "react";
import BookingDateSelect from "./BookingDatesSelect";
import BookingGuestSelect from "./BookingGuestSelect";

//scss
import "./style.scss";
import { useTheme } from "components/ListingNew/ListingTheme";

const DrawerContent = memo(
	({
		closeDrawer,
		listingList,
		dates,
		setDates,
		blocked,
		onClose,
		setContent,
		content,
		sameDay,
		spl,
		storedDates,
		openDrawer,
	}) => {
		let key,
			keys = Object.keys(listingList);
		let n = keys.length;
		let typeData = {};
		while (n--) {
			key = keys[n];
			if (key === "no_of_beds") {
				typeData["NO_OF_BEDROOMS"] = listingList[key];
			} else {
				typeData[key.toUpperCase()] = listingList[key];
			}
		}
		const landbot = document?.querySelectorAll(".LandbotLivechat");

		const theme = useTheme();

		useEffect(() => {
			if (landbot.length > 0) {
				landbot.forEach((ele) => {
					ele.style.display = "none";
				});
			}
			return () => {
				if (landbot) {
					landbot.forEach((ele) => {
						ele.style.display = "block";
					});
				}
			};
		}, [openDrawer, landbot]);

		return (
			<div
				className="booking-drawer-content"
				style={{ background: theme.background }}
			>
				{
					{
						dates: (
							<BookingDateSelect
								dates={dates}
								setDates={setDates}
								blocked={blocked}
								onClose={onClose}
								closeDrawer={closeDrawer}
								sameDay={sameDay}
								spl={spl}
								storedDates={storedDates}
							/>
						),
						guests: (
							<BookingGuestSelect
								setContent={setContent}
								listingList={typeData}
								onClose={onClose}
							/>
						),
					}[content]
				}
			</div>
		);
	},
);

export default DrawerContent;
